import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_206c4002 from 'nuxt_plugin_plugin_206c4002' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_4ec14ac4 from 'nuxt_plugin_bootstrapvue_4ec14ac4' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_plugin_fee30762 from 'nuxt_plugin_plugin_fee30762' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_index_40b25d99 from 'nuxt_plugin_index_40b25d99' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_libplugin3077b325_07474b68 from 'nuxt_plugin_libplugin3077b325_07474b68' // Source: ./lib.plugin.3077b325.js (mode: 'all')
import nuxt_plugin_workbox_18973571 from 'nuxt_plugin_workbox_18973571' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_1fbf08f8 from 'nuxt_plugin_metaplugin_1fbf08f8' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_166fbe10 from 'nuxt_plugin_iconplugin_166fbe10' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_onesignal_4d69f706 from 'nuxt_plugin_onesignal_4d69f706' // Source: ./onesignal.js (mode: 'client')
import nuxt_plugin_gtm_1176f9ab from 'nuxt_plugin_gtm_1176f9ab' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_storeCtl_2bc4ffc9 from 'nuxt_plugin_storeCtl_2bc4ffc9' // Source: ../plugins/storeCtl.js (mode: 'all')
import nuxt_plugin_router_3f7e063d from 'nuxt_plugin_router_3f7e063d' // Source: ../plugins/router (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_appConfigs_25493df8 from 'nuxt_plugin_appConfigs_25493df8' // Source: ../plugins/appConfigs (mode: 'all')
import nuxt_plugin_checkUpdate_35e82506 from 'nuxt_plugin_checkUpdate_35e82506' // Source: ../plugins/checkUpdate (mode: 'all')
import nuxt_plugin_filters_14a52510 from 'nuxt_plugin_filters_14a52510' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_lazyload_2b09a22e from 'nuxt_plugin_lazyload_2b09a22e' // Source: ../plugins/lazyload.js (mode: 'all')
import nuxt_plugin_localStorage_08604484 from 'nuxt_plugin_localStorage_08604484' // Source: ../plugins/localStorage (mode: 'all')
import nuxt_plugin_v2touch_3c3492bc from 'nuxt_plugin_v2touch_3c3492bc' // Source: ../plugins/v2-touch (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_visibly_797d6012 from 'nuxt_plugin_visibly_797d6012' // Source: ../plugins/visibly (mode: 'all')
import nuxt_plugin_payjp_22f2167a from 'nuxt_plugin_payjp_22f2167a' // Source: ../plugins/payjp (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"スマホdeMEMU","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"http-equiv":"content-language","content":"ja"},{"name":"viewport","content":"width=device-width,initial-scale=1.0,minimum-scale=1.0,user-scalable=no"},{"hid":"description","name":"description","content":"オーダー管理システム"},{"hid":"og:site_name","property":"og:site_name","content":"スマホdeMEMU"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fshp.spde.menu"},{"hid":"og:title","property":"og:title","content":"スマホdeMEMU"},{"hid":"og:description","property":"og:description","content":"オーダー管理システム"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fshp.spde.menu\u002Fogp.png"},{"name":"twitter:card","content":"summary"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"}],"script":[{"src":"https:\u002F\u002Fjs.pay.jp\u002Fv2\u002Fpay.js","defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"async":true,"src":"https:\u002F\u002Fcdn.onesignal.com\u002Fsdks\u002FOneSignalSDK.js","hid":"onesignal"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_206c4002 === 'function') {
    await nuxt_plugin_plugin_206c4002(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_4ec14ac4 === 'function') {
    await nuxt_plugin_bootstrapvue_4ec14ac4(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_fee30762 === 'function') {
    await nuxt_plugin_plugin_fee30762(app.context, inject)
  }

  if (typeof nuxt_plugin_index_40b25d99 === 'function') {
    await nuxt_plugin_index_40b25d99(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin3077b325_07474b68 === 'function') {
    await nuxt_plugin_libplugin3077b325_07474b68(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_18973571 === 'function') {
    await nuxt_plugin_workbox_18973571(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_1fbf08f8 === 'function') {
    await nuxt_plugin_metaplugin_1fbf08f8(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_166fbe10 === 'function') {
    await nuxt_plugin_iconplugin_166fbe10(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_onesignal_4d69f706 === 'function') {
    await nuxt_plugin_onesignal_4d69f706(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_1176f9ab === 'function') {
    await nuxt_plugin_gtm_1176f9ab(app.context, inject)
  }

  if (typeof nuxt_plugin_storeCtl_2bc4ffc9 === 'function') {
    await nuxt_plugin_storeCtl_2bc4ffc9(app.context, inject)
  }

  if (typeof nuxt_plugin_router_3f7e063d === 'function') {
    await nuxt_plugin_router_3f7e063d(app.context, inject)
  }

  if (typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_appConfigs_25493df8 === 'function') {
    await nuxt_plugin_appConfigs_25493df8(app.context, inject)
  }

  if (typeof nuxt_plugin_checkUpdate_35e82506 === 'function') {
    await nuxt_plugin_checkUpdate_35e82506(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_14a52510 === 'function') {
    await nuxt_plugin_filters_14a52510(app.context, inject)
  }

  if (typeof nuxt_plugin_lazyload_2b09a22e === 'function') {
    await nuxt_plugin_lazyload_2b09a22e(app.context, inject)
  }

  if (typeof nuxt_plugin_localStorage_08604484 === 'function') {
    await nuxt_plugin_localStorage_08604484(app.context, inject)
  }

  if (typeof nuxt_plugin_v2touch_3c3492bc === 'function') {
    await nuxt_plugin_v2touch_3c3492bc(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (typeof nuxt_plugin_visibly_797d6012 === 'function') {
    await nuxt_plugin_visibly_797d6012(app.context, inject)
  }

  if (typeof nuxt_plugin_payjp_22f2167a === 'function') {
    await nuxt_plugin_payjp_22f2167a(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
